import { useState } from "react";
import { Card } from "../../deck/primitives";

const TAGS = {
  market: ["Market Data", "bg-arq text-white border-arq"],
  avg: ["Market Average", "bg-arq-soft text-arq border-arq/40"],
  local: ["Local Submarket", "bg-arq-soft text-arq border-arq/40"],
  regional: ["Inland Empire Regional", "bg-[#EEF2F5] text-ink border-[#C9D3DB]"],
  uw: ["Arqitek Underwriting", "bg-ink text-white border-ink"],
  target: ["Target / Market-Validation Range", "bg-white text-arq border-arq border-dashed"],
  validate: ["To Be Validated by Leasing Broker", "bg-[#F8EDEE] text-[#8A3340] border-[#E2C2C6]"],
  illustrative: ["Illustrative", "bg-[#F1F3F5] text-[#5C6873] border-[#CFD5DC]"],
  internal: ["Arqitek Internal Screening Metric", "bg-[#F1F3F5] text-[#5C6873] border-[#CFD5DC]"],
  direct: ["Direct Comp", "bg-arq text-white border-arq"],
  secondary: ["Secondary Comp", "bg-arq-soft text-arq border-arq/40"],
  context: ["Market Context", "bg-[#F1F3F5] text-[#5C6873] border-[#CFD5DC]"],
};

export const Tag = ({ t, label }) => (
  <span data-testid={`mk-tag-${t}`} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-[3px] font-mono text-[9.5px] uppercase tracking-[0.12em] ${TAGS[t][1]}`}>
    {label || TAGS[t][0]}
  </span>
);

export const Src = ({ s, type, className = "" }) => (
  <div className={`mt-3 text-[10.5px] leading-relaxed text-steel ${className}`}>
    <span className="font-mono uppercase tracking-[0.1em]">Source</span> {s.source} · {s.date} · {s.geo}{type && ` · ${type}`} · Updated {s.updated}
  </div>
);

export const Stat = ({ label, value, sub, tag, src, type, accent, testid }) => (
  <Card data-testid={testid} className={`p-6 h-full metric-card ${accent ? "ring-1 ring-arq/40" : ""}`}>
    <div className="flex flex-col items-start gap-2">
      {tag && <Tag t={tag} />}
      <div className="text-xs text-steel">{label}</div>
    </div>
    <div className={`mt-4 font-display text-4xl tabular-nums leading-none ${accent ? "text-arq" : "text-ink"}`}>{value}</div>
    {sub && <div className="mt-2 text-sm text-char/80">{sub}</div>}
    {src && <Src s={src} type={type} />}
  </Card>
);

export const NumIn = ({ value, onChange, step = 1, w = "w-20", testid, prefix, suffix }) => (
  <span className="inline-flex items-center gap-1 rounded-md border border-line bg-white px-2 py-1 focus-within:border-arq transition-colors">
    {prefix && <span className="text-[11px] text-steel">{prefix}</span>}
    <input data-testid={testid} type="number" step={step} value={value} onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))}
      className={`${w} text-right text-sm tabular-nums text-ink bg-transparent outline-none`} />
    {suffix && <span className="text-[11px] text-steel">{suffix}</span>}
  </span>
);

export const ConfirmAction = ({ label, prompt, onConfirm, testid, primary }) => {
  const [ask, setAsk] = useState(false);
  if (!ask)
    return (
      <button data-testid={testid} onClick={() => setAsk(true)} className={`rounded-full px-5 py-2.5 text-sm transition-colors ${primary ? "bg-arq text-white hover:bg-arq-dark" : "border border-line bg-white text-ink hover:border-arq/50"}`}>
        {label}
      </button>
    );
  return (
    <div data-testid={`${testid}-confirm`} className="flex flex-wrap items-center gap-2 rounded-full border border-arq/40 bg-arq-soft pl-4 pr-1 py-1 text-xs text-ink">
      <span>{prompt}</span>
      <button data-testid={`${testid}-yes`} onClick={() => { onConfirm(); setAsk(false); }} className="rounded-full bg-arq text-white px-3 py-1.5">Apply</button>
      <button data-testid={`${testid}-no`} onClick={() => setAsk(false)} className="rounded-full px-3 py-1.5 text-steel hover:text-ink">Cancel</button>
    </div>
  );
};

export const HBars = ({ rows, max, fmt, testid }) => (
  <div data-testid={testid} className="space-y-5">
    {rows.map((r) => (
      <div key={r.label}>
        <div className="flex justify-between text-sm mb-2">
          <span className={r.hl ? "text-arq font-medium" : "text-char"}>{r.label}</span>
          <span className={`tabular-nums ${r.hl ? "text-arq font-semibold" : "text-ink"}`}>{fmt(r.value)}</span>
        </div>
        <div className="h-3 rounded-full bg-paper overflow-hidden">
          <div className={`h-full rounded-full transition-[width] duration-700 ${r.hl ? "bg-arq" : r.dark ? "bg-ink" : "bg-[#9FB0BC]"}`} style={{ width: `${Math.min((r.value / max) * 100, 100)}%` }} />
        </div>
      </div>
    ))}
  </div>
);
